import {
	DeviceStatus,
	DeviceStatusWithDisplayDto,
	FetchDeviceWithHistoryDto,
} from "../models/Device";
import { PermissionaryConfiguration } from "../models/PermissionaryConfiguration";

export const derivedDeviceStatuses: DeviceStatusWithDisplayDto[] = [
	{
		status: DeviceStatus.ONLINE,
		displayName: "En linea",
	},
	{
		status: DeviceStatus.ERROR,
		displayName: "Error",
	},
	{
		status: DeviceStatus.OFFLINE,
		displayName: "Fuera de linea",
	},
];

export function getDerivedDeviceStatus(
	device: FetchDeviceWithHistoryDto,
	permissionaryConfiguration: PermissionaryConfiguration | null,
): DeviceStatus | null {
	if (!permissionaryConfiguration || (device.history || [])?.length === 0) {
		return null;
	}

	const newestDeviceHistory = device.history[0];
	const offlineThresholdSeconds = Number(
		permissionaryConfiguration.offlineThresholdSeconds,
	);
	const currentTimestamp = Math.floor(Date.now() / 1000);
	const isOffline =
		currentTimestamp - newestDeviceHistory.timestamp > offlineThresholdSeconds;

	if (isOffline) {
		return DeviceStatus.OFFLINE;
	}

	return newestDeviceHistory.deviceReport.online
		? DeviceStatus.ONLINE
		: DeviceStatus.ERROR;
}
